import img1 from "../assets/20251013_164902.jpg";
import img2 from "../assets/20251013_165006.jpg";
import img3 from "../assets/20251013_165310.jpg";
import img4 from "../assets/20251013_165119.jpg";
import img5 from "../assets/20251013_165135.jpg";
import img6 from "../assets/20251013_165239.jpg";
import img7 from "../assets/20251013_165342.jpg";
import img8 from "../assets/20251013_165516.jpg";
import img9 from "../assets/20251013_165709.jpg";

const images = [img1, img2, img3, img4, img5, img6, img7, img8, img9];

const Media = () => {
  return (
    <section className="py-12 container mx-auto">
      {/* <h2 className="text-3xl font-bold text-center mb-8">Our Facilities</h2> */}
      <div className="w-[90%] mx-auto h-[600px] grid grid-cols-5 grid-rows-3 gap-2">
        {/* Video: Top-left, spanning 2 rows and 3 columns */}
        <div className="col-span-3 row-span-2">
          <iframe
            src="https://www.youtube.com/embed/M9AkWsdTlXo?si=A9NWI0MLZcr8-KhN" // Replace with your gym's video
            title="Gym Video"
            className="w-full h-full rounded-lg"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
        </div>
        {/* Images: Fill remaining 9 cells */}
        {images.map((src, idx) => (
          <div key={idx} className="bg-gray-200">
            <img
              src={src}
              alt={`Gym Image ${idx + 1}`}
              className="w-full h-full object-cover rounded-lg"
            />
          </div>
        ))}
      </div>
    </section>
  );
};

export default Media;